import { render, staticRenderFns } from "./SalesOrderApproval.vue?vue&type=template&id=20f94693&scoped=true&"
import script from "./SalesOrderApproval.vue?vue&type=script&lang=js&"
export * from "./SalesOrderApproval.vue?vue&type=script&lang=js&"
import style0 from "./SalesOrderApproval.vue?vue&type=style&index=0&id=20f94693&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20f94693",
  null
  
)

export default component.exports